// import React from "react";

// const Careerbanner = () => {
//   const bannerStyles = {
//    // marginTop: "60px",
//     width: "100%",
//     height: "90vh",
//     backgroundImage: "url('/image/careerban.webp')",
//     backgroundSize: "cover",
//     backgroundPosition: "center center",
//     display: "flex",
//     justifyContent: "flex-start",  
//     alignItems: "center",  
//     textAlign: "left", 
//     color: "white",
//     position: "relative",
//     overflow: "hidden",
//     fontFamily: "Arial, sans-serif",
//     paddingLeft: "8%", 
//   };

//   const contentStyles = {
//     maxWidth: "700px",
//     padding: "0 20px",
//     animation: "slideUp 1.5s ease-out forwards",
//     opacity: 0,
//      marginBottom:"-160px",
//   };

//   const headingStyles = {
//     fontSize: "36px",
//     margin: 0,
//     lineHeight: 1.2,
//     fontWeight: "bold",
//     // textShadow: "2px 2px 5px rgba(0,0,0,0.6)",
//     color:"black",
//    letterSpacing:"0px",
//   };

//   const paragraphStyles = {
//     fontSize: "28px",
//     marginTop: "1rem",
//     // textShadow: "1px 1px 4px rgba(0,0,0,0.5)",
//     textAlign:"justify",
//     color:"#025261",
//       fontWeight: "bold",
//   };

//   return (
//     <>
//       <style>
//         {`
//           @keyframes slideUp {
//             0% {
//               transform: translateY(50px);
//               opacity: 0;
//             }
//             100% {
//               transform: translateY(0);
//               opacity: 1;
//             }
//           }

//           /* Responsive styles */
//           @media (max-width: 1200px) {
//             h1 {
//               font-size: 1.5rem !important;
//             }
//             p {
//               font-size: 1rem !important;
//             }
//           }
//           @media (max-width: 768px) {
//             h1 {
//               font-size: 1.5rem !important;
//             }
//             p {
//               font-size: 1rem !important;
//             }
//           }
//           @media (max-width: 480px) {
//             h1 {
//               font-size: 1rem !important;
//             }
//             p {
//               font-size: 1rem !important;
//             }
//           }
//         `}
//       </style>

//       <div style={bannerStyles}>
//         <div style={contentStyles}>
//           <h1 style={headingStyles}>
//             Empower Your Career with Us.
//           </h1>
//           <p style={paragraphStyles}>
//             Our reinvention
// starts with you.
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Careerbanner;



import React from "react";

const Careerbanner = () => {
  const bannerStyles = {
    width: "100%",
    height: "50vh",
    backgroundImage: "url('/image/ssas.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    textAlign: "left",
    position: "relative",
    overflow: "hidden",
    fontFamily: "Arial, sans-serif",
    paddingLeft: "8%",
  };

  const contentStyles = {
    maxWidth: "700px",
    padding: "0 20px",
    animation: "slideUp 1.5s ease-out forwards",
    opacity: 0,
    marginBottom: "-160px",
  };

  const headingStyles = {
    fontSize: "36px",
    margin: 0,
    lineHeight: 1.2,
    fontWeight: "bold",
    color: "white",
  };

  const paragraphStyles = {
    fontSize: "28px",
    marginTop: "1rem",
    color: "white",
    fontWeight: "bold",
    textAlign: "justify",
  };

  return (
    <>
      <style>
        {`
          /* Animation */
          @keyframes slideUp {
            0% {
              transform: translateY(50px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }

          /* Overlay for clear text */
          .career-banner::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(9, 1, 1, 0.26);
            z-index: 1;
          }

          /* Content above overlay */
          .career-banner-content {
            position: relative;
            z-index: 2;
          }

          /* Responsive */
          @media (max-width: 1200px) {
            h1 { font-size: 2rem !important; }
            p { font-size: 1.3rem !important; }
          }

          @media (max-width: 768px) {
            h1 { font-size: 1.5rem !important; }
            p { font-size: 1.1rem !important; }
          }

          @media (max-width: 480px) {
            h1 { font-size: 1.2rem !important; }
            p { font-size: 1rem !important; }
          }
        `}
      </style>

      <div style={bannerStyles} className="career-banner">
        <div style={contentStyles} className="career-banner-content">
          <h1 style={headingStyles}>
            Empower Your Career with Us.
          </h1>
          <p style={paragraphStyles}>
            Our reinvention starts with you.
          </p>
        </div>
      </div>
    </>
  );
};

export default Careerbanner;

